import create from 'zustand/vanilla';
import { PaymentMethod, NicePaySuccessResponse } from '@/types/nicepay';

/**
 * 결제 상태
 */
export type PaymentStatus = 'idle' | 'processing' | 'success' | 'failed';

/**
 * 결제 상태 인터페이스
 */
interface PaymentState {
    /** 결제 진행 상태 */
    status: PaymentStatus;
    /** 거래 ID */
    transactionId?: string;
    /** 주문 ID */
    orderId?: string;
    /** 결제 금액 */
    amount?: number;
    /** 결제 수단 */
    paymentMethod?: PaymentMethod;
    /** 결제 상세 정보 */
    paymentDetails?: NicePaySuccessResponse;
    /** 에러 메시지 */
    errorMessage?: string;
    /** 에러 코드 */
    errorCode?: string;
}

/**
 * 결제 Store 인터페이스
 */
export interface PaymentStore extends PaymentState {
    /** 결제 시작 */
    startPayment: (orderId: string, amount: number, method: PaymentMethod) => void;
    /** 결제 성공 */
    setPaymentSuccess: (
        transactionId: string,
        orderId: string,
        amount: number,
        method: PaymentMethod,
        details?: NicePaySuccessResponse
    ) => void;
    /** 결제 실패 */
    setPaymentFailed: (errorCode: string, errorMessage: string) => void;
    /** Store 초기화 */
    resetPayment: () => void;
}

/**
 * 초기 상태
 */
const initialState: PaymentState = {
    status: 'idle',
    transactionId: undefined,
    orderId: undefined,
    amount: undefined,
    paymentMethod: undefined,
    paymentDetails: undefined,
    errorMessage: undefined,
    errorCode: undefined,
};

/**
 * 결제 Store
 */
export const paymentStore = create<PaymentStore>((set) => ({
    ...initialState,

    startPayment: (orderId, amount, method) => {
        set({
            status: 'processing',
            orderId,
            amount,
            paymentMethod: method,
            transactionId: undefined,
            paymentDetails: undefined,
            errorMessage: undefined,
            errorCode: undefined,
        });
    },

    setPaymentSuccess: (transactionId, orderId, amount, method, details) => {
        set({
            status: 'success',
            transactionId,
            orderId,
            amount,
            paymentMethod: method,
            paymentDetails: details,
            errorMessage: undefined,
            errorCode: undefined,
        });
    },

    setPaymentFailed: (errorCode, errorMessage) => {
        set({
            status: 'failed',
            errorCode,
            errorMessage,
        });
    },

    resetPayment: () => {
        set(initialState);
    },
}));

export default paymentStore;
